<div class="page-header">
  <div>
    <h1>Hub</h1>
    <p>{{ t('HubDashboardIntro') }}</p>
  </div>
</div>

<div class="dashboard-grid">
  <a class="dashboard-card" routerLink="/forms">
    <span>{{ t('DonationFormPageLink') }}</span>
    <strong>{{ t('HubDashboardFormsTitle') }}</strong>
    <small>{{ t('HubDashboardFormsText') }}</small>
  </a>
  <a class="dashboard-card" routerLink="/processes">
    <span>{{ t('ProcessPageLink') }}</span>
    <strong>{{ t('HubDashboardProcessesTitle') }}</strong>
    <small>{{ t('HubDashboardProcessesText') }}</small>
  </a>
  <a class="dashboard-card" routerLink="/settings">
    <span>{{ t('NgoSettingsLink') }}</span>
    <strong>{{ t('HubDashboardSettingsTitle') }}</strong>
    <small>{{ t('HubDashboardSettingsText') }}</small>
  </a>
</div>
